import { ScheduleRequestReviewStatus } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { CheckListPopoverFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { SCHEDULE_REQUEST_STATUS_LABELS } from '../../constants';
import { trackingIds } from '../../tracking-ids';

interface ScheduleRequestStatusFilterProps {
  value?: ScheduleRequestReviewStatus[];
  onChange: (value: ScheduleRequestReviewStatus[]) => void;
}

export const ScheduleRequestStatusFilter = ({ value, onChange }: ScheduleRequestStatusFilterProps) => {
  const { t } = useTranslation('analytics');

  return (
    <CheckListPopoverFilterSelector
      options={SCHEDULE_REQUEST_STATUS_LABELS}
      label={t('Appointment Outcome')}
      defaultValue={[]}
      onChange={(status) => onChange(status as ScheduleRequestReviewStatus[])}
      renderIcon={(isFilterActive) => <Icon name='calendar-small' color={isFilterActive ? 'white' : 'default'} />}
      value={value ?? []}
      trackingId={`${trackingIds.scheduleRequestsFilter}-status`}
      disableClearWhenEmpty
    />
  );
};
